app.controller("SearchWatcherFormController",
	["$scope", "$http", "ApartmentSearchService", "BrowserStorageService", "$window", function($scope, $http, ApartmentSearchService, BrowserStorageService, $window) {
		$scope.errors = {};
		$scope.sendingForm = false;
		$scope.submitted = false;
		$scope.disabled = false;

		var watchParams = ApartmentSearchService.CreateQuery().MergeStorageQueryBlob(BrowserStorageService.LocalStorage.GetItem('ApartmentSearchQuery')).GetAsAPIQueryObject();

		/* Do we have query in watchParams? */

		if (watchParams['query[]'] === undefined || !Array.isArray(watchParams['query[]']) || watchParams['query[]'].length === 0) {
			$scope.errors.watchParams = true;
			$scope.disabled = true;
		}

		$scope.submitForm = function() {
			var errors = {
				firstName: 'Syötä etunimesi',
				lastName: 'Syötä sukunimesi',
				streetAddress: 'Syötä osoite',
				postCode: 'Syötä postinumero',
				email: 'Virheellinen sähköpostiosoite',
				phone: 'Syötä puhelinnumero',
				name: 'Anna vahdille nimi',
				watchParams: true
			};
			if ($scope.errors == null) {
				$scope.errors = {};
			}

			$scope.sendingForm = true;


			/**
			 * Scroll to top of the form if it's not in the view
			 */
			var formElement = document.querySelector('.head-start-form__form'),
				formTop = formElement.getBoundingClientRect().top;
			if (formTop <= 90) {
				Utils.ScrollTo('.head-start-form__form', 50);
			}


			var searchWatchData = {
				firstName: $scope.firstName,
				lastName: $scope.lastName,
				streetAddress: $scope.streetAddress,
				postCode: $scope.postCode,
				email: $scope.email,
				phone: $scope.phone,
				name: $scope.name,
				watchParams: watchParams
			};
			if ($window.wakeTestEmail !== undefined) {
				searchWatchData.wakeTestEmail = $window.wakeTestEmail;
			}

			$http({
				method: "POST",
				url: "/api/km/KMSite/addSearchWatch",
				data: searchWatchData
			})
			.then(function(data) {
				$scope.sendingForm = false;
				$scope.errors = {};
				$scope.submitted = true;
				$scope.thank_you = 'Kiitos 24h Etumatkan tilauksesta!';
				
				setTimeout(function() {
					$scope.firstName = '';
					$scope.lastName = '';
					$scope.streetAddress = '';
					$scope.postCode = '';
					$scope.email = '';
					$scope.phone = '';
					$scope.name = '';

					$scope.submitted = false;

					$scope.$apply();
				}, 6000);

				_gaq.push(['_trackEvent', '24h Etumatka', 'Lähetä']);

			},
			function(results) {
				$scope.sendingForm = false;
				
				for (var key in results.data.data) {
					if(!results.data.data[key].success) {
						$scope.errors[key] = errors[key];
					} else {
						$scope.errors[key] = null;
					}
				}
			});
		};
	}]
);
